export default "__VITE_PUBLIC_ASSET__6e195ba7__"